import { Literals } from "shared/types";
import classNames from "shared/utils/classNames";

import BackButton from "./BackButton";

type Props = {
  copyTexts: Literals;
  onBackClick: () => void;
  isIframe?: boolean;
};
export const TopBarSupportTicket = (props: Props) => {
  const { copyTexts, onBackClick, isIframe } = props;
  return (
    <div className="flex items-center gap-2">
      <BackButton
        onBackClick={onBackClick}
        copyTexts={copyTexts}
        isIframe={isIframe}
      />
      <p
        className={classNames(
          "flex items-start font-semibold leading-6",
          isIframe ? "" : "text-[var(--invertedColor)]",
        )}
      >
        {copyTexts.supportTicketFormTitle}
      </p>
    </div>
  );
};
